import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

//assets
import background from "assets/images/sbs-landing-background.png";

// constant
import { SortList } from "constants/filters";

// styles
import styles from "./Home.module.scss";

// store
import useFiltersStore from "store/useFiltersStoreNew";
import { useSearchStore } from "store/searchStore";
import useColumnsStore from "store/useColumnsStore";
import useExportColumnStore from "store/useExportColumnStore";

// components
import SearchBarNew from "components/SearchBarNew/SearchBarNew";
import { Button } from "components/LibraryComponents/Components";
import NotificationBanner from "components/NotifcationBanner/NotificationBanner";

// icons
import { ArrowRight } from "components/icons";

export default function HomePage() {
  const { clearFilters } = useFiltersStore((state) => ({
    clearFilters: state.clearFilters,
  }));

  const { setResultSorting } = useSearchStore((state) => ({
    setResultSorting: state.setResultSorting,
  }));

  const { clear } = useColumnsStore((state) => ({
    clear: state.clear,
  }));

  const { clear: clearExportColumns } = useExportColumnStore((state) => ({
    clear: state.clear,
  }));

  useEffect(() => {
    clearFilters();
    setResultSorting(SortList[0]);
    clear()
    clearExportColumns()
  }, [])

  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Small Business Search</title>
      </Helmet>
      <NotificationBanner />
      <div className={styles["home-root"]}>
        <div className={styles["background"]}>
          <img src={background} alt="background" />
        </div>
        <div className={styles["content"]}>
          <div className={styles["heading-wrapper"]}>
            <h1 className={styles["heading"]}>
              Find the right small businesses <strong>fast</strong>.
            </h1>

            <h2 className={styles["sub-heading"]}>
              Small businesses everywhere are seeking federal contracts. <br />{" "}
              Find the ones that meet your agency’s needs right now.
            </h2>
          </div>

          <div className={styles["input-wrapper"]}>
            <SearchBarNew />
          </div>

          <div className={styles["skip-wrapper"]}>
            <Button
              type="button"
              className={styles["skip-button"]}
              aria-label="Visit advanced search page"
              onClick={() => {
                navigate("/advanced");
              }}
            >
              Or, skip directly to search filters <ArrowRight />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
